export const CITY_SCOPE_BRAND_NAME = "City Scope";

export const CITY_SCOPE_BRAND_SEARCH_VARIANTS = [
  "City Scope",
  "city scope",
  "CityScope",
  "cityscope",
  "City-Scope",
  "city-scope",
  "city-scope.co.uk",
];

export const CITY_SCOPE_BRAND_ALTERNATE_NAMES = CITY_SCOPE_BRAND_SEARCH_VARIANTS.filter(
  (variant) => variant !== CITY_SCOPE_BRAND_NAME
);

export const CITY_SCOPE_BRAND_KEYWORDS = CITY_SCOPE_BRAND_SEARCH_VARIANTS.join(", ");

export const CITY_SCOPE_BRAND_SEARCH_COPY =
  "City Scope is also searched for as CityScope, cityscope and city-scope.";
